export const ACCESS_TOKEN_KEY = 'adminAccessToken';
export const LEGACY_ACCESS_TOKEN_KEY = 'adminToken';
export const REFRESH_TOKEN_KEY = 'adminRefreshToken';
export const ADMIN_USER_KEY = 'adminUser';

export const getDisplayName = (value, fallback = 'Unknown') => {
  if (!value) {
    return fallback;
  }

  if (typeof value === 'string') {
    return value.trim() || fallback;
  }

  if (value.fullName) {
    return value.fullName;
  }

  if (value.name) {
    return value.name;
  }

  const composedName = [value.firstName, value.lastName].filter(Boolean).join(' ').trim();
  if (composedName) {
    return composedName;
  }

  return fallback;
};

export const getInitials = (value, fallback = '?') => {
  const name = getDisplayName(value, '');
  if (!name) {
    return fallback;
  }

  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

  return initials || fallback;
};

export const formatDate = (value, options = {}) => {
  if (!value) {
    return 'N/A';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return 'N/A';
  }

  return date.toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options,
  });
};

export const formatTime = (value) => {
  if (!value) {
    return 'N/A';
  }

  if (/^\d{1,2}:\d{2}$/.test(value)) {
    return value;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatCurrency = (amount, currency = 'INR') => {
  const numericAmount = Number(amount ?? 0);
  if (Number.isNaN(numericAmount)) {
    return 'N/A';
  }

  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(numericAmount);
  } catch (error) {
    return `${currency} ${numericAmount}`;
  }
};

export const slugToLabel = (value) => {
  if (!value) {
    return 'N/A';
  }

  return String(value)
    .split('_')
    .join(' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const toDateInputValue = (value) => {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return date.toISOString().split('T')[0];
};

export const toIsoDateString = (value) => {
  if (!value) {
    return undefined;
  }

  return new Date(`${value}T00:00:00.000Z`).toISOString();
};

export const getApiErrorMessage = (error, fallback = 'Something went wrong') =>
  error?.response?.data?.error ||
  error?.response?.data?.message ||
  fallback;
